/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./bitgetWalletAirdrop.vue?vue&type=template&id=285f482a&scoped=true"
import script from "./bitgetWalletAirdrop.vue?vue&type=script&lang=js"
export * from "./bitgetWalletAirdrop.vue?vue&type=script&lang=js"
import style1 from "./bitgetWalletAirdrop.vue?vue&type=style&index=1&id=285f482a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f482a",
  null
  
)

export default component.exports